export default {
  /* Custom Cognito Messges */
  CustomRegistrationSuccess: 'User Registered Successfully. Check email to activate your account.',
  CustomActivateSuccess: 'Account activated successfully. You can login now.',
  CustomResendSuccess: 'Verification code send Successfully. Check email to activate your account.',
  CustomForgotPasswordSuccess: 'Request for forgot password received. Check email for your verification code.',
  CustomPasswordChangedSuccess: 'Password changed successfully.',
  CustomPasswordResetSuccess: 'Password changed successfully. You can login now.',
  /** Cognito Messages */
  UsernameExistsException: 'Email already there',
};



// WEBPACK FOOTER //
// ./src/config/CustomMessageList.js